module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "none",
      "list-type": "picture-card",
      "multiple": _vm.multiple,
      "accept": _vm.accept,
      "file-list": _vm.postData,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-change": _vm.onChange,
      "on-exceed": _vm.onExceed,
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.uploadFile,
      "limit": _vm.limit,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return _c('div', {}, [(_vm.videoFlag == true) ? _c('el-progress', {
          attrs: {
            "type": "circle",
            "percentage": _vm.videoUploadPercent
          }
        }) : _c('img', {
          staticClass: "el-upload-list__item-thumbnail",
          attrs: {
            "src": file.url + '?x-oss-process=video/snapshot,t_10,f_jpg,w_0,h_0,m_fast,ar_auto',
            "alt": ""
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "el-upload-list__item-actions"
        }, [_c('span', {
          staticClass: "el-upload-list__item-preview",
          on: {
            "click": function($event) {
              return _vm.onPreview(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-video-play"
        })]), _vm._v(" "), (!_vm.disabled) ? _c('span', {
          staticClass: "el-upload-list__item-delete",
          on: {
            "click": function($event) {
              return _vm.onRemove(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })]) : _vm._e()])], 1)
      }
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.dialogImageUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d4cddf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/VideoUploader.vue
// module id = 1367
// module chunks = 0